import type { Template } from "./types";
import { useState } from "react";
import CustomTemplateEditor from "./customTemplateEditor";

interface TemplatePickerProps {
  templates: Template[];
  currentTemplate: Template;
  disabled?: boolean;
  onSelect: (template: Template) => void;
}

export default function TemplatePicker({
  templates,
  currentTemplate,
  disabled = false,
  onSelect,
}: TemplatePickerProps) {
  const [showCustomTemplateEditor, setShowCustomTemplateEditor] = useState(false);
  return (
    <div>
      <div className="template-picker-header">
        <div>
          <h3>Template</h3>
          <p>Wähle das Layout für deinen Post.</p>
        </div>

        <span className="template-current">
            {currentTemplate?.name ?? "Kein Template ausgewählt"}
        </span>
      </div>

      <button
          type="button"
          className="btn-primary"
          onClick={() =>
              setShowCustomTemplateEditor(true)
          }
      >
          Eigenes Template erstellen
      </button>
      {showCustomTemplateEditor && (
    <div
        style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: 30,
        }}
        onClick={() =>
            setShowCustomTemplateEditor(false)
        }
    >
        <div
            style={{
                position: "relative",
                width: "min(900px, 92vw)",
                maxHeight: "88vh",
                background: "#fff",
                borderRadius: 12,
                overflowY: "auto",
                padding: "28px 32px",
                boxShadow:
                    "0 15px 50px rgba(0,0,0,0.3)",
            }}
            onClick={(event) =>
                event.stopPropagation()
            }
        >
            <button
                type="button"
                onClick={() =>
                    setShowCustomTemplateEditor(false)
                }
                aria-label="Editor schließen"
                style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    width: 34,
                    height: 34,
                    border: "none",
                    borderRadius: "50%",
                    background: "#eee",
                    cursor: "pointer",
                    fontSize: 22,
                    zIndex: 10,
                }}
            >
                ×
            </button>

            <div
              style={{
                  maxWidth: 820,
                  margin: "0 auto",
              }}
          >
              <CustomTemplateEditor />
          </div>
        </div>
    </div>
)}

      <div className="template-grid">
        {templates.map((template) => {
          const selected =
            currentTemplate?.name === template.name;

          return (
            <button
              key={template.name}
              type="button"
              className={`template-card ${
                selected ? "template-card--selected" : ""
              }`}
              onClick={() => onSelect(template)}
              disabled={disabled}
            >
              <div className="template-card__preview">
                <img
                  src={template.src}
                  alt={`Vorschau für ${template.name}`}
                />

                {selected && (
                  <span className="template-card__check">
                    ✓
                  </span>
                )}
              </div>

              <div className="template-card__name">
                {template.name}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}